import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { Filter, X } from "react-feather";

/**
 * UsersFilter - Filter component for users view
 */
const UsersFilter = ({ filters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  // Check if current user is ADMIN
  const isAdmin = () => {
    try {
      const userData = localStorage.getItem("user_data");
      if (userData) {
        const parsedData = JSON.parse(userData);
        return parsedData.userType === "ADMIN";
      }
    } catch (error) {
      console.error("Error checking user type:", error);
    }
    return false;
  };

  const handleChange = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const defaultFilters = {
      partnerUuid: null,
      name: "",
      userType: null,
      active: null,
      sort: "-createdDate",
    };
    setLocalFilters(defaultFilters);
    onClearFilters();
  };

  const userIsAdmin = isAdmin();

  return (
    <div className="users-filter mb-3 p-3 border rounded">
      <h6 className="mb-3">
        <Filter size={16} className="me-2" />
        Filters
      </h6>
      <Row>
        <Col md="3">
          <FormGroup>
            <Label for="filterName">Name / Username</Label>
            <Input
              id="filterName"
              type="text"
              placeholder="Search by name..."
              value={localFilters.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </FormGroup>
        </Col>
        {userIsAdmin && (
          <Col md="3">
            <FormGroup>
              <Label for="filterPartnerUuid">Partner UUID</Label>
              <Input
                id="filterPartnerUuid"
                type="text"
                placeholder="Filter by partner UUID..."
                value={localFilters.partnerUuid || ""}
                onChange={(e) => handleChange("partnerUuid", e.target.value || null)}
              />
            </FormGroup>
          </Col>
        )}
        <Col md="2">
          <FormGroup>
            <Label for="filterUserType">User Type</Label>
            <Input
              id="filterUserType"
              type="select"
              value={localFilters.userType || ""}
              onChange={(e) => handleChange("userType", e.target.value || null)}
            >
              <option value="">All Types</option>
              <option value="ADMIN">ADMIN</option>
              <option value="MANAGER">MANAGER</option>
              <option value="USER">USER</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label for="filterActive">Status</Label>
            <Input
              id="filterActive"
              type="select"
              value={localFilters.active === null ? "" : localFilters.active.toString()}
              onChange={(e) => {
                const value = e.target.value;
                handleChange("active", value === "" ? null : value === "true");
              }}
            >
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label for="filterSort">Sort By</Label>
            <Input
              id="filterSort"
              type="select"
              value={localFilters.sort}
              onChange={(e) => handleChange("sort", e.target.value)}
            >
              <option value="-createdDate">Newest First</option>
              <option value="createdDate">Oldest First</option>
              <option value="userName">Username A-Z</option>
              <option value="-userName">Username Z-A</option>
              <option value="email">Email A-Z</option>
              <option value="-email">Email Z-A</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="1" className="d-flex align-items-end">
          <FormGroup>
            <Button
              color="primary"
              onClick={handleApply}
              className="w-100"
              title="Apply Filters"
            >
              <Filter size={14} />
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="secondary"
            size="sm"
            outline
            onClick={handleClear}
          >
            <X size={14} className="me-1" />
            Clear Filters
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default UsersFilter;
